import { FC, useState } from 'react'
import Svg from '@components/svg'
import {
  StyleButton,
  StyleInput,
  StyleInputWrapper,
  StyleSearchWrapper,
} from './style'
interface SearchProps {
  onSubmit: (value: string) => void
  placeholder?: string
  loading?: boolean
}
const Search: FC<SearchProps> = ({
  onSubmit,
  placeholder = 'Search...',
  loading,
}) => {
  const [search, setSearch] = useState('')

  return (
    <StyleSearchWrapper>
      <StyleInputWrapper>
        <Svg svg="search" color={'placeholder'} />
        <StyleInput
          placeholder={placeholder}
          onChange={(event) => {
            setSearch(event.target.value)
          }}
        />
      </StyleInputWrapper>
      <StyleButton
        type="button"
        onClick={() => {
          onSubmit?.(search)
        }}
      >
        {!!loading ? 'Loading...' : 'Search'}
      </StyleButton>
    </StyleSearchWrapper>
  )
}

export default Search
